/**
 * DatePicker Component
 *
 * Native date input with Indonesian formatting.
 * Defaults to max date of today (no future dates).
 */

import { getLocalDateString } from '../../lib/dateUtils';

interface DatePickerProps {
	value: string;
	onChange: (value: string) => void;
	maxDate?: string;
	label?: string;
	id?: string;
	disabled?: boolean;
}

/**
 * Format a date string for display in Indonesian format
 */
function formatDateIndonesian(dateStr: string): string {
	if (!dateStr) return '';
	const date = new Date(dateStr);
	return date.toLocaleDateString('id-ID', {
		weekday: 'long',
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});
}

export function DatePicker({
	value,
	onChange,
	maxDate = getLocalDateString(),
	label = 'Tanggal',
	id = 'date-picker',
	disabled = false,
}: DatePickerProps) {
	return (
		<div className="space-y-1">
			{label && (
				<label
					htmlFor={id}
					className="block text-sm font-medium text-gray-700"
				>
					{label}
				</label>
			)}
			<div className="relative">
				<input
					type="date"
					id={id}
					value={value}
					onChange={(e) => onChange(e.target.value)}
					max={maxDate}
					disabled={disabled}
					className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition disabled:bg-gray-100 disabled:cursor-not-allowed"
				/>
			</div>
			{value && (
				<p className="text-sm text-gray-500">
					{formatDateIndonesian(value)}
				</p>
			)}
		</div>
	);
}
